import {closeModal, fadeIn, fadeOut, openModal} from "./utils/common";
import {AnswerType, EMAIL_REGEX, ERROR_CLASS, FILL_CLASS} from "./utils/consts";
import {Api} from "./api/api";

export class PriceRequest {
  #document = document;
  #api = new Api();

  #modalElement = this.#document.querySelector(`.js-price-request-modal`);
  #nameElement = this.#modalElement.querySelector(`.js-price-request-name`);
  #imageElement = this.#modalElement.querySelector(`.js-price-request-img`);
  #brandElement = this.#modalElement.querySelector(`.js-price-request-brand`);
  #vendorCodeElement = this.#modalElement.querySelector(`.js-price-request-vendor-code`);
  #sizeContainerElement = this.#modalElement.querySelector(`.js-price-request-size-container`);
  #sizeElement = this.#sizeContainerElement.querySelector(`.js-price-request-size`);

  #id;

  #formElement = this.#modalElement.querySelector(`.js-price-request-form`);
  #textFieldsElements = this.#formElement.querySelectorAll(`[data-validation-type]`);
  #nameInputElement = this.#formElement.querySelector(`[data-validation-type="name"]`);
  #emailInputElement = this.#formElement.querySelector(`[data-validation-type="email"]`);
  #submitButton = this.#formElement.querySelector(`.js-fast-order-submit`);

  #answerElement = this.#formElement.querySelector(`.js-price-request-answer`);
  #successAnswerElement = this.#answerElement.querySelector(`.js-success`);
  #failAnswerElement = this.#answerElement.querySelector(`.js-fail`);

  constructor() {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onTextFieldInput = this.onTextFieldInput.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onSubmitButtonMouseenter = this.onSubmitButtonMouseenter.bind(this);
  }

  init() {
    this.#document.addEventListener(`click`, this.onDocumentClick);
    this.#formElement.addEventListener(`submit`, this.onFormSubmit);
    this.#submitButton.addEventListener(`mouseenter`, this.onSubmitButtonMouseenter);
    this.#textFieldsElements.forEach((textField) => {
      textField.addEventListener(`input`, this.onTextFieldInput);
    });
  }

  #validateElement = {
    name: (element) => element.value.length,
    email: (element) => element.value.match(EMAIL_REGEX),
  };

  #showModal() {
    openModal(this.#modalElement, `flex`);
  }

  #hideModal() {
    closeModal(this.#modalElement);
  }

  #showAnswer(type) {
    fadeIn(this.#answerElement, 200, `flex`);
    switch (type) {
      case AnswerType.SUCCESS:
        fadeIn(this.#successAnswerElement, 200, `block`);
        break;
      case AnswerType.FAIL:
        fadeIn(this.#failAnswerElement, 200, `block`);
        break;
    }
  }

  #hideAnswer(type) {
    fadeOut(this.#answerElement, 200);
    switch (type) {
      case AnswerType.SUCCESS:
        fadeOut(this.#successAnswerElement, 200);
        break;
      case AnswerType.FAIL:
        fadeOut(this.#failAnswerElement, 200);
        break;
    }
  }

  #resetForm() {
    this.#formElement.reset();
  }

  #getNameValidationStatus() {
    return this.#nameInputElement.classList.contains(FILL_CLASS);
  }

  #getEmailValidationStatus() {
    return this.#emailInputElement.classList.contains(FILL_CLASS);
  }

  #validateTextFieldInput(element, type, isSubmitHover) {
    if (this.#validateElement[type](element)) {
      element.classList.remove(ERROR_CLASS);
      element.classList.add(FILL_CLASS);
    } else {
      element.classList.remove(FILL_CLASS);

      if (isSubmitHover) {
        element.classList.add(ERROR_CLASS);
      }
    }
  }

  #fillProductData(target) {
    this.#imageElement.src = target.dataset.imageSrc;
    this.#nameElement.textContent = target.dataset.productName.trim();
    this.#brandElement.textContent = target.dataset.brand.trim();
    this.#vendorCodeElement.textContent = target.dataset.vendorCode.trim();
    const productSize = target.dataset.size;

    if (productSize) {
      this.#sizeContainerElement.classList.remove(`request__option--hide`);
      this.#sizeElement.textContent = productSize.trim();
    } else {
      this.#sizeContainerElement.classList.add(`request__option--hide`);
    }
  }

  #setId(target) {
    this.#id = target.dataset.id;
  }

  #appendIdToFormData(formData) {
    formData.append("productId", this.#id);
  }

  onTextFieldInput(evt) {
    const self = evt.currentTarget;
    const type = self.dataset.validationType;

    this.#validateTextFieldInput(self, type);
  }

  onSubmitButtonMouseenter() {
    this.#textFieldsElements.forEach((textFieldElement) => {
      const type = textFieldElement.dataset.validationType;
      this.#validateTextFieldInput(textFieldElement, type, true);
    });
  }

  onDocumentClick(evt) {
    const target = evt.target;

    if (target.classList.contains(`js-price-request-open`)) {
      this.#showModal();
      this.#fillProductData(target);
      this.#setId(target);
    }

    if (target.classList.contains(`js-price-request-close`)) {
      this.#hideModal();
    }
  }

  async onFormSubmit(evt) {
    if (!this.#getNameValidationStatus() || !this.#getEmailValidationStatus()) {
      evt.preventDefault();
    } else {
      evt.preventDefault();
      const formData = new FormData(this.#formElement);

      this.#appendIdToFormData(formData);

      this.#api.sendPriceRequest(formData).then((data) => {
        if (data === 200) {
          this.#showAnswer(AnswerType.SUCCESS);
          this.#resetForm();
          setTimeout(() => {
            this.#hideAnswer(AnswerType.SUCCESS);
          }, 4000);
        } else {
          this.#showAnswer(AnswerType.FAIL);
          setTimeout(() => {
            this.#hideAnswer(AnswerType.FAIL);
          }, 4000);
        }
      });
    }
  }
}
